import { render, staticRenderFns } from "./customDetails.vue?vue&type=template&id=49eefad6&scoped=true&"
import script from "./customDetails.vue?vue&type=script&lang=js&"
export * from "./customDetails.vue?vue&type=script&lang=js&"
import style0 from "./customDetails.vue?vue&type=style&index=0&id=49eefad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eefad6",
  null
  
)

component.options.__file = "customDetails.vue"
export default component.exports